import { Directive, Input, TemplateRef, ViewContainerRef, OnDestroy } from '@angular/core';
import { enableDisableView } from './if-feature-flag-enabled.directive';
import { Observable, Subject } from 'rxjs';
import { WebAngularSharedDataAccessFeatureFlagApisService } from '../services/feature-flags.service';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appIfFeatureFlagDisabledAsync]'
})
export class IfFeatureFlagDisbaledAsyncDirective implements OnDestroy {
  private currentViewState = false;
  private flag$: Observable<any>;
  private onDestroy: Subject<any> = new Subject();

  @Input()
  set appIfFeatureFlagDisabledAsync(flagName: string) {
    this.flag$ = this.featureFlagsService.getFlagAsync(flagName);

    this.flag$.pipe(takeUntil(this.onDestroy)).subscribe((value: boolean) => {
      const enableView = !value;
      this.currentViewState = enableDisableView(
        enableView,
        this.viewContainer,
        this.templateRef,
        this.currentViewState
      );
    });
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private featureFlagsService: WebAngularSharedDataAccessFeatureFlagApisService
  ) {}

  ngOnDestroy() {
    this.onDestroy.next(null);
  }
}
